import { render } from "./IconHand.vue?vue&type=template&id=446b3e72"
import script from "./IconHand.vue?vue&type=script&lang=js"
export * from "./IconHand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__